import moment from 'moment';
import fetch from '../lib/fetch';
import { WEB_RTC_FEATURES_MAP, WEB_RTC_CAMERAS_MAP, detect as detectWebRTC } from './webrtc';
import { CHAT_BOT_TYPE_MAP, START_FAIL as START_BOT_FAIL, start as startBot } from './bot.js';
import download from 'downloadjs';
import { reportError } from '../app';
import isMobile from 'is-mobile';
import { printSentFile, PRINT } from './companion';

export const CHAT_PART = {
  customer: 'chat-part/customer',
  agent: 'chat-part/agent',
};

const CHAT_PARTICIPANT = new Map([
  [1, CHAT_PART.agent],
  [2, CHAT_PART.customer],
]);

export const CHAT_MODAL = {
  chooseCamera: 1,
  fileUpload: 2
};

export const START = 'chat/start';
export const START_REQUEST = 'chat/start-request';
export const START_FAIL = 'chat/start-fail';
export const CONFIGURATION = 'chat/configuration';
export const start = () => dispatch => {
  dispatch({ type: START_REQUEST });

  return fetch('chat/configuration', { method: 'GET' }).then(configuration => {
    configuration.allowedWebRTCFeatures = configuration.allowedWebRTCFeatures
      .map(f => WEB_RTC_FEATURES_MAP.get(f));
    configuration.mainVideoDisplay = CHAT_PARTICIPANT.get(configuration.mainVideoDisplay);
    configuration.preferedVideoMode = WEB_RTC_FEATURES_MAP.get(configuration.preferedVideoMode);
    configuration.preferedCamera = WEB_RTC_CAMERAS_MAP.get(configuration.preferedCamera);
    if (configuration.bot && configuration.bot.enabled) {
      configuration.bot.type = CHAT_BOT_TYPE_MAP.get(configuration.bot.type);
      configuration.bot.supported = typeof window.WebSocket === 'function';
    }
    dispatch({ type: CONFIGURATION, configuration });

    let startPromise;

    if (!configuration.bot || !configuration.bot.enabled || !configuration.bot.supported) {
      startPromise = dispatch(startHub());
    } else {
      startPromise = dispatch(startBot(configuration.bot));
    }

    startPromise.then(action => {
      if (![START_HUB_FAIL, START_BOT_FAIL].includes(action.type)) {
        return dispatch({ type: START });
      } else {
        return dispatch({ type: START_FAIL, error: action.error });
      }
    });
  }).catch(error => dispatch({ type: START_FAIL, error }));
}

export const START_HUB = 'chat/start/hub';
export const START_HUB_REQUEST = 'chat/start/hub/request';
export const START_HUB_FAIL = 'chat/start/hub/fail';
export const START_HUB_HISTORY = 'chat/start/hub/history';
export const startHub = (chatRequestId, connectionId) => dispatch => {
  dispatch({ type: START_HUB_REQUEST });

  if (connectionId) {
    return dispatch({ type: START_HUB, chatData: {} });
  }

  if (chatRequestId) {
    return fetch(`chat/resume/${chatRequestId}`, { method: 'POST' })
      .then(chatData => {
        window.ExpRSATpCol = chatData.rsaExp;
        window.ModRSATpCol = chatData.rsaMod;
        window.ChallengeRSATpCol = '';
        dispatch(requestNotification());
        return dispatch({ type: START_HUB, chatData });
      })
      .catch(error => dispatch({ type: START_HUB_FAIL, error }));
  }
  else {
    return fetch('chat', { method: 'POST' })
      .then(chatData => {
        window.ExpRSATpCol = chatData.rsaExp;
        window.ModRSATpCol = chatData.rsaMod;
        window.ChallengeRSATpCol = '';
        dispatch(requestNotification());

        if (chatData.history) {
          dispatch({ type: START_HUB_HISTORY, chatHistory: chatData.history });
        }

        return dispatch({ type: START_HUB, chatData });
      })
      .catch(error => dispatch({ type: START_HUB_FAIL, error }));
  }
}

export const OUT_OF_SCHEDULE = 'chat/out-of-schedule';
export const OUT_OF_SCHEDULE_REQUEST = 'chat/out-of-schedule-request';
export const OUT_OF_SCHEDULE_FAIL = 'chat/out-of-schedule-fail';
export const outOfScheduleData = () => dispatch => {
  dispatch({ type: OUT_OF_SCHEDULE_REQUEST });

  return fetch('schedule', { method: 'GET' })
    .then(schedule => dispatch({ type: OUT_OF_SCHEDULE, schedule }))
    .catch(error => dispatch({ type: OUT_OF_SCHEDULE_FAIL, error }));
}

export const INIT_ERROR = 'chat/init-error';
export const initError = error => ({ type: INIT_ERROR, error });

export const HUB_STARTED = 'chat/hub-started';
export const HUB_START_ERROR = 'chat/hub-start-error';
export const hubStart = () => ({ type: HUB_STARTED });
export const hubStartError = () => ({ type: HUB_START_ERROR });

export const ROUTING_RETRY = 'chat/routing-retry';
export const ROUTING_TIMEOUT = 'chat/routing-abort';
export const ROUTING_OFFER_KEEP_WAITING = 'chat/routing-offer-keep-waiting';
// routingFail is not an action creator, it returns one
export const routingFail = ({
  tryAgain, startTime, timeoutInMinutes, abort, offerKeepWaiting, routingAttempts,
  delayBetweenRoutingAttempts, delayBeforeOfferingToKeepWaiting, offeredToKeepWaiting
}) => dispatch => queuePosition => {
  let routings = routingAttempts() + 1;

  if (moment().isSameOrAfter(moment(startTime()).add(timeoutInMinutes, 'minutes'))) {
    abort();
    dispatch({ type: ROUTING_TIMEOUT });
    return;
  }

  if (offerKeepWaiting && !offeredToKeepWaiting()) {
    if (routings * delayBetweenRoutingAttempts / 1000 >= delayBeforeOfferingToKeepWaiting) {
      dispatch({ type: ROUTING_OFFER_KEEP_WAITING });
    }
  }

  tryAgain();
  return dispatch({ type: ROUTING_RETRY, routingAttempts: routings, queuePosition });
};
export const ROUTING_KEEP_WAITING = 'chat/routing-keep-waiting';
export const ROUTING_STOP_WAITING = 'chat/routing-stop-waiting';
export const ROUTING_STOP_WAITING_REQUEST = 'chat/routing-stop-waiting-request';
export const ROUTING_STOP_WAITING_FAIL = 'chat/routing-stop-waiting-fail';
export const keepWaiting = () => ({ type: ROUTING_KEEP_WAITING });
export const stopWaiting = (chatRequestId, abort) => dispatch => {
  dispatch({ type: ROUTING_STOP_WAITING_REQUEST });
  abort();

  return fetch('chat/contactbyemail/' + chatRequestId, { method: 'POST', expect: 'text' })
    .then(result => dispatch({ type: ROUTING_STOP_WAITING }))
    .catch(error => dispatch({ type: ROUTING_STOP_WAITING_FAIL, error }));
};
export const ROUTING_SUCCESS = 'chat/routing-success';

export const routingSuccess = (
  detectWebRTCAgentSide, queueID, allowedWebRTCFeatures, customSiteUrlHexEncoded,
  connectionId
) => dispatch => detectWebRTC(
  dispatch, detectWebRTCAgentSide, queueID, allowedWebRTCFeatures, customSiteUrlHexEncoded,
  connectionId
).then(() => dispatch({ type: ROUTING_SUCCESS, connectionId }));

export const NOTIFICATION_REQUEST = 'chat/notification/request';
export const NOTIFICATION_REQUEST_DENIED = 'chat/notification/request/denied';
export const NOTIFICATION_REQUEST_DISMISSED = 'chat/notification/request/dismissed';
export const NOTIFICATION_REQUEST_GRANTED = 'chat/notification/request/granted';
export const NOTIFICATION_REQUEST_FAILED = 'chat/notification/request/failed';
export const requestNotification = () => dispatch => {
  if (
    typeof Notification !== 'undefined' 
    && typeof Notification.requestPermission === 'function'
    && !isMobile()
  ) {
    return Notification.permission === 'granted'
      ? dispatch({ type: NOTIFICATION_REQUEST_GRANTED })
      : Notification.requestPermission().then(result => {
        if (result === 'denied') {
          return dispatch({ type: NOTIFICATION_REQUEST_DENIED });
        }
        if (result === 'default') {
          return dispatch({ type: NOTIFICATION_REQUEST_DISMISSED });
        }
        return { type: NOTIFICATION_REQUEST_GRANTED };
      }).catch(error => dispatch({ type: NOTIFICATION_REQUEST_FAILED, error }));
    };
};

export const FOCUS = 'chat/focus';
export const BLUR = 'chat/blur';
export const focus = () => ({ type: FOCUS });
export const blur = () => ({ type: BLUR });

export const ENDED = 'chat/ended';
export const chatEnded = (part, surveyTextHeader) => ({ type: ENDED, part, surveyTextHeader });

export const NETWORK_ERROR = 'chat/network-error';
export const NETWORK_ERROR_RECONNECT = `${NETWORK_ERROR}/reconnect`;
export const networkError = (surveyTextHeader, error) => dispatch => {
  if (typeof error === 'string') {
    const lowerCaseError = error.toLowerCase();

    if (lowerCaseError.indexOf('signalr error: error: the client has been inactive since') !== -1) {
      dispatch(chatEnded(CHAT_PART.customer, surveyTextHeader));
      error = 'Se cerró la conversación por inactividad. Por favor no deje la página por mucho tiempo para mantener la conversación abierta.';
    }
  }
  reportError(error);
  return dispatch({ type: NETWORK_ERROR, error });
};

const agentHeaderRegEx = /\[agentheader\]/i;
const pendingRegEx = /\[pending\]/i;
export const MESSAGE_RECEIVED = 'chat/message-received';
export const MESSAGE_RECEIVED_IMAGE = `${MESSAGE_RECEIVED}/image`;
export const MESSAGE_RECEIVED_FILE = `${MESSAGE_RECEIVED}/file`;
export const MESSAGE_RECEIVED_ERROR = `${MESSAGE_RECEIVED}/error`;
export const NOTIFY_MESSAGE_RECEIVED = 'chat/notify/message/received';
export const messageReceived = ({
  companionConfiguration = {},
  notify = false,
  pendingNotifications = 1,
  notificationTitle,
  notificationTitlePlural,
  notificationOptions
}, message, agentHeader) => async dispatch => {
  let notification;

  const imageMatch = /\[tpclient_external_image:(\S*)\]/.exec(message);
  const fileMatch = /\[tpclient_external_file:(\S*)\]/.exec(message);

  if (notify && typeof Notification !== 'undefined') {
    notification = new Notification(
      pendingNotifications + 1 > 1
        ? notificationTitlePlural.replace(agentHeaderRegEx, agentHeader).replace(pendingRegEx, pendingNotifications + 1)
        : notificationTitle.replace(agentHeaderRegEx, agentHeader)
      , { ...notificationOptions, body: imageMatch || fileMatch ? '.' : message }
    );
    dispatch({ type: NOTIFY_MESSAGE_RECEIVED });
  }

  if (imageMatch) {
    const guid = imageMatch[1];
    return fetch(`chat/file/${guid}`, { method: 'GET', expect: 'text' })
      .then(image => dispatch({ type: MESSAGE_RECEIVED_IMAGE, guid, image }))
      .catch(error => {
        console.error(error);

        return dispatch({ 
          type: MESSAGE_RECEIVED_ERROR, 
          message: 'Error recibiendo imagen enviada por el agente'
        });
      });
  }

  if (fileMatch) {
    const guid = fileMatch[1];
    let name;

    try {
      name = await fetch(`chat/file/${guid}/name`, { method: 'GET', expect: 'text' });
    } catch(error) {
      reportError(error);
      return dispatch({ 
        type: MESSAGE_RECEIVED_ERROR, 
        message: 'Error recibiendo archivo enviado por el agente'
      });
    }

    let printed = null;

    if (companionConfiguration && companionConfiguration.printEnabled) {
      if (companionConfiguration.forcePrint) {
        try {
          printed = (await dispatch(printSentFile(guid, name))).type === PRINT;
        } catch (error) {
          reportError(error);
          printed = false;
        }
      } else {
        // TODO: Ask to print da file to the agent
        throw new Error('Not implemented');
      }

      if (!printed) {
        printed = false;
      }
    }

    return dispatch({ type: MESSAGE_RECEIVED_FILE, guid, name, printed });
  }

  return dispatch({ type: MESSAGE_RECEIVED, message, notify, name: agentHeader, notification });
};

export const DOWNLOAD_FILE = 'chat/file/download';
export const DOWNLOAD_FILE_REQUEST = `${DOWNLOAD_FILE}/request`;
export const DOWNLOAD_FILE_FAIL = `${DOWNLOAD_FILE}/fail`;
export const downloadFile = (guid, fileName) => dispatch => {
  dispatch({ type: DOWNLOAD_FILE_REQUEST });

  return fetch(`chat/file/${guid}`, {
    method: 'GET', expect: 'blob'
  }).then(blob => download(blob, fileName)
      .then(() => dispatch({ type: DOWNLOAD_FILE })))
    .catch(error => dispatch({ type: DOWNLOAD_FILE_FAIL, error }));
};

export const MESSAGE_SENT = 'chat/message-sent';
export const messageSent = (message, userRenderHeader) => ({ type: MESSAGE_SENT, message, name: userRenderHeader });

export const USER_TYPING = 'chat/user-typing';
export const USER_NOT_TYPING = 'chat/user-not-typing';
export const userTyping = () => ({ type: USER_TYPING });
export const userNotTyping = () => ({ type: USER_NOT_TYPING });

export const AGENT_TYPING = 'chat/agent-typing';
export const AGENT_NOT_TYPING = 'chat/agent-not-typing';
export const agentTyping = () => ({ type: AGENT_TYPING });
export const agentNotTyping = () => ({ type: AGENT_NOT_TYPING });

export const SEND_MAIL_TRANSCRIPT_REQUEST = 'chat/send-mail-transcript-request';
export const SEND_MAIL_TRANSCRIPT = 'chat/send-mail-transcript';
export const SEND_MAIL_TRANSCRIPT_ERROR = 'chat/send-mail-transcript-error';
export const sendMailTranscript = () => ({ type: SEND_MAIL_TRANSCRIPT_REQUEST });
export const sendMailTranscriptSuccess = () => ({ type: SEND_MAIL_TRANSCRIPT });
export const sendMailTranscriptError = () => ({ type: SEND_MAIL_TRANSCRIPT_ERROR });

export const CLOSE_MODAL = 'chat/close-modal';
export const closeModal = () => ({ type: CLOSE_MODAL });


const imagePrefix = 'chat/image/';

export const SELECT_IMAGE = `${imagePrefix}select`;
export const selectImage = guid => ({ type: SELECT_IMAGE, guid });

export const CLOSE_IMAGE = `${imagePrefix}close`;
export const closeImage = () => ({ type: CLOSE_IMAGE });


// WEBPACK FOOTER //
// ./actions/chat/index.js